
const appIndex = [
    {
        'Intro': [{
            name: 'Intro',
            component: 'Intro',
            active: true
        }]
    },
    {
        'Patterns': [
            {
                name: 'Cards',
                component: 'Cards',
                active: false
            },
            {
                name: 'Modals',
                component: 'Modals',
                active: false
            },
            {
                name: 'Forms',
                component: 'Forms',
                active: false
            },
            {
                name: 'Hero Sections',
                component: 'HeroSections',
                active: false
            },
        ]
    },
    {
        'Components': [
            {
                name: 'Alerts',
                component: 'Alerts',
                active: false
            },
            {
                name: 'Avatars',
                component: 'Avatars',
                active: false
            },
            {
                name: 'Badges',
                component: 'Badges',
                active: false
            },
            
            {
                name: 'Buttons',
                component: 'Buttons',
                active: false
            },
            
            {
                name: 'Images',
                component: 'Images',
                active: false
            },
            
            {
                name: 'Inputs',
                component: 'Inputs',
                active: false
            },
            
            {
                name: 'Navbars',
                component: 'Navbars',
                active: false
            },
        ]
    },
    
    {
        'Classes': [
            {
                name: 'Background color',
                component: 'BackgroundColor',
                active: false
            },
            {
                name: 'Border Color',
                component: 'BorderColor',
                active: false
            },
            {
                name: 'Flex',
                component: 'Flex',
                active: false
            },
            {
                name: 'Grid',
                component: 'Grid',
                active: false
            },
            {
                name: 'Font Style',
                component: 'FontStyle',
                active: false
            },
            {
                name: 'Margin',
                component: 'Margin',
                active: false
            },
            {
                name: 'Padding',
                component: 'Padding',
                active: false
            },
            {
                name: 'Text color',
                component: 'TextColor',
                active: false
            },
            {
                name: 'Text size',
                component: 'TextSize',
                active: false
            },
            {
                name: 'Height',
                component: 'Height',
                active: false
            },
            {
                name: 'Width',
                component: 'Width',
                active: false
            },
            {
                name: 'Utilities',
                component: 'Utilities',
                active: false
            },
        ]
    },
]

export default appIndex;
